import { useApiMutation } from "@babackapp/private-api-client/client/use-api-mutation";
import { $api } from "@babackapp/private-api-client/generated/client";
import type { UpdateShopAdminDto } from "@babackapp/private-api-client/generated/schema";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

const shopAdminQueryKey = (shopId: string) => [
  "get",
  "/shops/{shopId}/admin",
  { params: { path: { shopId } } },
];

/**
 * Baback-internal shop settings. Readable by any shop member (the sidebar demo
 * button reacts to them); only super admins can write, see `useUpdateShopAdmin`.
 */
export function useCurrentShopAdmin() {
  const { shopId } = useParams<{ shopId: string }>();

  return $api.useQuery(
    "get",
    "/shops/{shopId}/admin",
    { params: { path: { shopId: shopId! } } },
    { enabled: !!shopId },
  );
}

export function useUpdateShopAdmin(shopId: string) {
  const queryClient = useQueryClient();

  return useApiMutation("patch", "/shops/{shopId}/admin", {
    invalidate: () =>
      queryClient.invalidateQueries({ queryKey: shopAdminQueryKey(shopId) }),
    mapVariables: (body: UpdateShopAdminDto) => ({
      params: { path: { shopId } },
      body,
    }),
  });
}
